module.exports = __webpack_public_path__ + "img/icon-chevron-down.6381e104.svg";